var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"7","height":"9","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill":"#000","transform":"rotate(90 3.5 4)","fill-rule":"evenodd","d":"M3.5 1L7 7 0 7z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }